import type { FC } from 'react';
import { FormField } from '@george-labs.com/design-system';
import type { ColSize } from '@george-labs.com/design-system/types/components/Layout';
import type { FORM_FIELD_LABEL_POSITION } from '@george-labs.com/design-system/types/components/Form';

import { LazyFormPhoneInput } from './LazyFormPhoneInput';
import type { FormFieldProps } from '../types/FormFieldProps';

interface Props extends FormFieldProps {
    labelColumnWidth?: ColSize;
    required?: boolean;
    disabled?: boolean;
    autoFocus?: boolean;
    info?: string;
}

interface FormPhoneFieldStatics {
    LABEL_POSITION: typeof FORM_FIELD_LABEL_POSITION;
}

export const FormPhoneField: FC<Props> & FormPhoneFieldStatics = ({
    label,
    labelPosition,
    labelColumnWidth,
    'data-cy': dataCy,
    fieldName,
    required,
    disabled,
    autoFocus,
    info,
    alert,
    description,
}) => {
    return (
        <FormField
            label={label}
            labelPosition={labelPosition}
            labelColumnWidth={labelColumnWidth}
            required={required}
            description={description}
            alert={alert}
        >
            <LazyFormPhoneInput
                fieldName={fieldName}
                data-cy={dataCy}
                disabled={disabled}
                autoFocus={autoFocus}
                info={info}
                label={label}
            />
        </FormField>
    );
};

FormPhoneField.LABEL_POSITION = FormField.LABEL_POSITION;
